module.exports = __webpack_public_path__ + "static/media/ethiopian_coffee_exporters_association.fa539303.jpg";